webpackJsonp([213130420965792],{

/***/ 96:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var DISQUS_CONFIG = ['shortname', 'identifier', 'title', 'url', 'category_id', 'onNewComment', 'language'];
	var __disqusAdded = false;
	
	function copyProps(context, props) {
	    var onNewComment = props.onNewComment,
	        language = props.language,
	        rest = _objectWithoutProperties(props, ['onNewComment', 'language']);
	
	    for (var prop in rest) {
	        context.page[prop] = rest[prop];
	    }
	
	    // Setting the language - if none is provided, the default one is used
	    context.language = language;
	
	    if (onNewComment) {
	        context.callbacks = {
	            onNewComment: [onNewComment]
	        };
	    }
	}
	
	var DisqusThread = function (_React$Component) {
	    _inherits(DisqusThread, _React$Component);
	
	    function DisqusThread() {
	        _classCallCheck(this, DisqusThread);
	
	        return _possibleConstructorReturn(this, (DisqusThread.__proto__ || Object.getPrototypeOf(DisqusThread)).apply(this, arguments));
	    }
	
	    _createClass(DisqusThread, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.loadDisqus();
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {
	            this.loadDisqus();
	        }
	    }, {
	        key: 'shouldComponentUpdate',
	        value: function shouldComponentUpdate(nextProps, nextState) {
	            return nextProps.identifier !== this.props.identifier;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var props = Object.keys(this.props).reduce(function (memo, key) {
	                return DISQUS_CONFIG.some(function (config) {
	                    return config === key;
	                }) ? memo : _extends({}, memo, _defineProperty({}, key, _this2.props[key]));
	            }, {});
	
	            return _react2.default.createElement(
	                'div',
	                props,
	                _react2.default.createElement('div', { id: 'disqus_thread' })
	            );
	        }
	    }, {
	        key: 'addDisqusScript',
	        value: function addDisqusScript() {
	            if (__disqusAdded) {
	                return;
	            }
	
	            var child = this.disqus = document.createElement('script');
	            var parent = document.getElementsByTagName('head')[0] || document.getElementsByTagName('body')[0];
	
	            child.async = true;
	            child.type = 'text/javascript';
	            child.src = '//' + this.props.shortname + '.disqus.com/embed.js';
	
	            parent.appendChild(child);
	            __disqusAdded = true;
	        }
	    }, {
	        key: 'loadDisqus',
	        value: function loadDisqus() {
	            var _this3 = this;
	
	            var props = {};
	
	            // Extract Disqus props that were supplied to this component
	            DISQUS_CONFIG.forEach(function (prop) {
	                // prop "shortname" is only necessary for loading the script, not for the config itself
	                if (prop !== 'shortname' && !!_this3.props[prop]) {
	                    props[prop] = _this3.props[prop];
	                }
	            });
	
	            // If Disqus has already been added, reset it
	            if (typeof DISQUS !== 'undefined') {
	                DISQUS.reset({
	                    reload: true,
	                    config: function config() {
	                        copyProps(this, props);
	
	                        // Disqus needs hashbang URL, see https://help.disqus.com/customer/portal/articles/472107
	                        this.page.url = this.page.url.replace(/#/, '') + '#!newthread';
	                    }
	                });
	            } else {
	                // Otherwise add Disqus to the page
	                window.disqus_config = function () {
	                    copyProps(this, props);
	                };
	                this.addDisqusScript();
	            }
	        }
	    }]);
	
	    return DisqusThread;
	}(_react2.default.Component);
	
	DisqusThread.displayName = 'DisqusThread';
	
	DisqusThread.propTypes = {
	    id: _propTypes2.default.string,
	
	    /**
	     * `shortname` tells the Disqus service your forum's shortname,
	     * which is the unique identifier for your website as registered
	     * on Disqus. If undefined , the Disqus embed will not load.
	     */
	    shortname: _propTypes2.default.string.isRequired,
	
	    /**
	     * `identifier` tells the Disqus service how to identify the
	     * current page. When the Disqus embed is loaded, the identifier
	     * is used to look up the correct thread. If disqus_identifier
	     * is undefined, the page's URL will be used. The URL can be
	     * unreliable, such as when renaming an article slug or changing
	     * domains, so we recommend using your own unique way of
	     * identifying a thread.
	     */
	    identifier: _propTypes2.default.string,
	
	    /**
	     * `title` tells the Disqus service the title of the current page.
	     * This is used when creating the thread on Disqus for the first time.
	     * If undefined, Disqus will use the <title> attribute of the page.
	     * If that attribute could not be used, Disqus will use the URL of the page.
	     */
	    title: _propTypes2.default.string,
	
	    /**
	     * `url` tells the Disqus service the URL of the current page.
	     * If undefined, Disqus will take the window.location.href.
	     * This URL is used to look up or create a thread if disqus_identifier
	     * is undefined. In addition, this URL is always saved when a thread is
	     * being created so that Disqus knows what page a thread belongs to.
	     */
	    url: _propTypes2.default.string,
	
	    /**
	     * `category_id` tells the Disqus service the category to be used for
	     * the current page. This is used when creating the thread on Disqus
	     * for the first time.
	     */
	    category_id: _propTypes2.default.string,
	
	    /**
	     * `onNewComment` function accepts one parameter `comment` which is a
	     * JavaScript object with comment `id` and `text`. This allows you to track
	     * user comments and replies and run a script after a comment is posted.
	     */
	    onNewComment: _propTypes2.default.func,
	
	    /**
	     * `language` tells the Disqus service which language should be used.
	     * Please refer to https://www.transifex.com/disqus/disqus/ on which languages can be used
	     * If undefined, English is used as default one
	     */
	    language: _propTypes2.default.string
	};
	
	DisqusThread.defaultProps = {
	    url: typeof window === 'undefined' ? null : window.location.href
	};
	
	exports.default = DisqusThread;

/***/ }),

/***/ 38:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(96);

/***/ }),

/***/ 69:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactEmotion = __webpack_require__(3);
	
	var _reactEmotion2 = _interopRequireDefault(_reactEmotion);
	
	var _format = __webpack_require__(114);
	
	var _format2 = _interopRequireDefault(_format);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// text-shadow: 0px 0px 0 ${props => props.theme.colors.warm.dark},
	// 2px 0px 0 ${props => props.theme.colors.cool.dark},
	// 0px 2px 0 ${props => props.theme.colors.cool.dark},
	// 2px 2px 0 ${props => props.theme.colors.cool.dark};
	
	var Wrapper = /*#__PURE__*/(0, _reactEmotion2.default)('div', {
	  target: 'ecsohkt0'
	})('padding-top:2rem;padding-bottom:2rem;img,tr,.gatsby-resp-iframe-wrapper{box-shadow:0px 2px 20px rgba(0,0,0,0.7);margin-bottom:1rem;}.gatsby-highlight{margin-bottom:2rem;}ul{list-style:none;margin-left:0;padding-left:0em;text-indent:-1.8rem;}p,li{list-style:none;letter-spacing:-0.003em;--baseline-multiplier:0.179;--x-height-multiplier:0.35;font-size:1.35rem;line-height:1.6;code{padding:0.2rem 0.5rem;margin:0.5rem 0;}}a{color:', function (props) {
	  return props.theme.set.light.p;
	}, ';border-bottom:3px solid ', function (props) {
	  return props.theme.set.light.a;
	}, ';text-shadow:', function (props) {
	  return props.theme.set.light.shadow.text.small;
	}, ';font-weight:600;transition:', function (props) {
	  return props.theme.transitions.main.transition;
	}, ';&:focus,&:hover{color:', function (props) {
	  return props.theme.set.light.h1;
	}, ';background-color:', function (props) {
	  return props.theme.set.light.highlight;
	}, ';}}h1,h2,h3,h4,h5,h6{a{color:', function (props) {
	  return props.theme.set.light.a;
	}, ';box-shadow:rgba(black,0);border-bottom:0;&:hover,&:focus{color:', function (props) {
	  return props.theme.set.light.highlight;
	}, ';background:none;}}}p,h1,h2,h3,h4,h5,h6,Text,li,ul{max-width:55rem;margin-left:auto;margin-right:auto;padding:0 2rem;}table,img,.gatsby-remark-imges,.gatsby-resp-image-wrapper,gatsby-remark-image{margin-top:1.5rem;max-width:1920px;margin-left:auto;margin-right:auto;box-shadow:0px 2px 20px rgba(0,0,0,0.7);}.gatsby-resp-image-wrapper{margin-bottom:1rem;transition:', function (props) {
	  return props.theme.transitions.boom;
	}, ';@media only screen and (orientation:portrait) and (max-device-aspect-ratio:1/1){width:175%;position:relative;left:-37%;:focus,:hover{width:100%;left:0;}}@media (min-width:1921px){width:100%;}}/*and (max-height:max-device-width) \n   and (max-width:max-height)\n  */\n  tr{border-radius:', function (props) {
	  return props.theme.borderRadius.round;
	}, ';}td,th{text-align:center;border-radius:', function (props) {
	  return props.theme.borderRadius.round;
	}, ';}table{width:90%;margin-left:auto;margin-right:auto;background-color:transparent;}h1{margin-top:2rem;margin-bottom:0.25rem;/* \n    margin-left:-0.06125rem;*/\n    /*\n    margin-left:-0.030625rem;*/\n\n    color:', function (props) {
	  return props.theme.set.light.h1;
	}, ';text-shadow:', function (props) {
	  return props.theme.set.light.shadow._3dThin;
	}, ';}h3{position:relative;margin-top:0.5rem;margin-bottom:0.25rem;}h6{font-size:1.5rem;margin-bottom:-0.5rem;margin-top:-1.5rem;color:', function (props) {
	  return props.theme.set.light.h1;
	}, ';text-shadow:', function (props) {
	  return props.theme.set.light.shadow._3dThin;
	}, ';}.subH{a{bottom-margin:-40rem;color:', function (props) {
	  return props.theme.set.light.a;
	}, ';box-shadow:rgba(black,0);border-bottom:0;&:hover,&:focus{color:', function (props) {
	  return props.theme.set.light.highlight;
	}, ';background:none;}}}.gifDiv{width:100%;img{width:100%;}@media (min-width:1000px){margin-bottom:2.5rem;}}.gatsby-highlight{div{max-width:200px;padding-top:2rem;padding-bottom:2rem;}}code{}.language-javascript{margin:2rem auto;max-width:864px;background-color:', function (props) {
	  return props.theme.colors.pure.ink;
	}, ';font-size:1.1225rem;font-size:1rem;font-family:\'Source Code Pro\',\'Courier New\',Courier,monospace;code{}}.language-text{font-family:\'Source Code Pro\',\'Courier New\',Courier,monospace;background-color:rgba(0,0,0,0);color:', function (props) {
	  return props.theme.set.light.p;
	}, ';code{}}/*\n  .media4x3 > iframe,div{max-width:100%;margin-left:auto;margin-right:auto;margin-bottom:2rem;div{box-shadow:0px 2px 20px rgba(0,0,0,0.7);}@media(min-width:1174px){div{box-shadow:0px 2px 20px rgba(0,0,0,0);top-margin:2rem;}iframe{box-shadow:0px 2px 20px rgba(0,0,0,0.7);}max-width:1172px;max-height:880px;margin-left:auto;margin-right:auto;}}.media4x3 > .gatsby-resp-iframe-wrapper,div{margin-top:1.5rem;max-width:100%;margin-left:auto;margin-right:auto;iframe{background-color:black;}@media(min-width:1174px){margin-top:0.5rem;max-width:1274px;max-height:880px;width:100%;height:100%;top:-1.08rem;margin-bottom:3rem;}}.media4x3{margin-left:auto;margin-right:auto;@media(min-width:1174px){position:absolute;top:1.65rem;left:1rem;}}.media16x9 > iframe,div{max-width:100%;margin-left:auto;margin-right:auto;margin-bottom:2rem;background-color:transparent;box-shadow:0px 2px 20px rgba(0,0,0,0);div{box-shadow:0px 2px 20px rgba(0,0,0,0.7);}@media(min-width:1921px){div{box-shadow:0px 2px 20px rgba(0,0,0,0);top-margin:20rem;}iframe{box-shadow:0px 2px 20px rgba(0,0,0,0.7);}max-width:1920px;max-height:1080px;margin-left:3rem;margin-right:3rem;}}.media16x9 > .gatsby-resp-iframe-wrapper,div{margin-top:2.5rem;max-width:100%;max-height:100%;background-color:transparent;margin-left:auto;margin-right:auto;iframe{background-color:black;}@media(min-width:1921px){margin-top:0.5rem;max-width:1920px;max-height:1080px;width:100%;height:100%;top:-1.08rem;margin-bottom:3rem;}*/\n  .media4x3{margin-left:auto;margin-right:auto;position:absolute;background-color:black;@media (min-width:1174px){min-width:1174px;min-height:880px;}}.media4x3 > .gatsby-resp-iframe-wrapper,div{max-width:1174px;max-height:880px;margin-left:auto;margin-right:auto;margin-top:1.5rem;}.media16x9{background-color:black;margin-left:auto;margin-right:auto;position:relative;top:-5rem;@media (min-width:1921px){min-width:1920px;min-height:1080px;}}.media16x9 > iframe,img{max-width:1920px;margin-left:auto;margin-right:auto;}');
	// import { toColorString } from 'polished';
	// import theme from '../../config/theme';
	
	var Content = function Content(_ref) {
	  var input = _ref.input;
	
	  // const updated = format(new Date(document.lastModified), 'MMM.DD.YYYY');
	  if (typeof document !== 'undefined') {
	    input = input.replace(/id="updated">(.*?)</gi, 'id="updated">' + (0, _format2.default)(new Date(document.lastModified), 'MMM.DD.YYYY') + '<');
	  }
	  return _react2.default.createElement(Wrapper, { dangerouslySetInnerHTML: { __html: input } });
	};
	exports.default = Content;
	
	
	Content.propTypes = {
	  input: _propTypes2.default.any.isRequired
	};
	module.exports = exports['default'];

/***/ }),

/***/ 70:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactEmotion = __webpack_require__(3);
	
	var _reactEmotion2 = _interopRequireDefault(_reactEmotion);
	
	var _reactDisqusComments = __webpack_require__(38);
	
	var _reactDisqusComments2 = _interopRequireDefault(_reactDisqusComments);
	
	var _Container = __webpack_require__(9);
	
	var _Container2 = _interopRequireDefault(_Container);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var StyledContainer = /*#__PURE__*/(0, _reactEmotion2.default)(_Container2.default, {
	  target: 'e1wkg3760'
	})('max-width:55rem;margin-bottom:4rem;padding-left:2rem;padding-right:2rem;');
	
	var DisqusContainer = function DisqusContainer(_ref) {
	  var children = _ref.children;
	  return _react2.default.createElement(
	    StyledContainer,
	    null,
	    children
	  );
	};
	
	exports.default = DisqusContainer;
	module.exports = exports['default'];

/***/ }),

/***/ 73:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactEmotion = __webpack_require__(3);
	
	var _reactEmotion2 = _interopRequireDefault(_reactEmotion);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CenterDiv = /*#__PURE__*/(0, _reactEmotion2.default)('div', {
	  target: 'eroyfwb0'
	})('position:absolute;z-index:9;width:100%;height:100%;background-color:', function (props) {
	  return props.theme.colors.night.tint;
	}, ';');
	
	var FxTint = function FxTint(props) {
	  var children = props.children;
	
	  return _react2.default.createElement(
	    CenterDiv,
	    { style: { backgroundColor: '' + props.color, opacity: '' + props.opacity } },
	    children
	  );
	};
	exports.default = FxTint;
	
	
	FxTint.propTypes = {
	  children: _propTypes2.default.node,
	  color: _propTypes2.default.string,
	  opacity: _propTypes2.default.number
	};
	
	FxTint.defaultProps = {
	  color: '',
	  opacity: 0.25
	};
	module.exports = exports['default'];

/***/ }),

/***/ 41:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(10);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _website = __webpack_require__(8);
	
	var _website2 = _interopRequireDefault(_website);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SEO = function SEO(props) {
	  var postNode = props.postNode,
	      postPath = props.postPath,
	      postSEO = props.postSEO;
	
	  var title = void 0;
	  var description = void 0;
	  var image = void 0;
	  var postURL = void 0;
	  if (postSEO) {
	    var postMeta = postNode.frontmatter;
	    title = postMeta.title; // eslint-disable-line prefer-destructuring
	    description = postNode.excerpt;
	    image = postMeta.cover.childImageSharp.resize.src;
	    postURL = _website2.default.siteUrl + _website2.default.pathPrefix + postPath;
	  } else {
	    title = _website2.default.siteTitle;
	    description = _website2.default.siteDescription;
	    image = _website2.default.siteBanner;
	  }
	  var realPrefix = _website2.default.pathPrefix === "/" ? "" : _website2.default.pathPrefix;
	  image = _website2.default.siteUrl + realPrefix + image;
	  var newsURL = _website2.default.siteUrl + _website2.default.pathPrefix;
	  var schemaOrgJSONLD = [{
	    "@context": "http://schema.org",
	    "@type": "WebSite",
	    url: newsURL,
	    name: title,
	    alternateName: _website2.default.siteTitleAlt ? _website2.default.siteTitleAlt : ""
	  }];
	  if (postSEO) {
	    schemaOrgJSONLD.push([{
	      "@context": "http://schema.org",
	      "@type": "BreadcrumbList",
	      itemListElement: [{
	        "@type": "ListItem",
	        position: 1,
	        item: {
	          "@id": postURL,
	          name: title,
	          image: image
	        }
	      }]
	    }, {
	      "@context": "http://schema.org",
	      "@type": "newsPosting",
	      url: newsURL,
	      name: title,
	      alternateName: _website2.default.siteTitleAlt,
	      headline: title,
	      image: {
	        "@type": "ImageObject",
	        url: image
	      },
	      description: description
	    }]);
	  }
	  return _react2.default.createElement(
	    _reactHelmet2.default,
	    null,
	    _react2.default.createElement("html", { lang: "en" }),
	    _react2.default.createElement(
	      "title",
	      null,
	      title
	    ),
	    _react2.default.createElement("meta", { name: "description", content: description }),
	    _react2.default.createElement("meta", { name: "image", content: image }),
	    _react2.default.createElement("meta", { charSet: "utf-8" }),
	    _react2.default.createElement("meta", { httpEquiv: "X-UA-Compatible", content: "IE=edge,chrome=1" }),
	    _react2.default.createElement("meta", { name: "viewport", content: "width=device-width, initial-scale=1" }),
	    _react2.default.createElement("link", {
	      rel: "apple-touch-icon",
	      sizes: "180x180",
	      href: "/favicons/apple-touch-icon.png"
	    }),
	    _react2.default.createElement("link", {
	      rel: "icon",
	      type: "image/png",
	      sizes: "32x32",
	      href: "/favicons/favicon-32x32.png"
	    }),
	    _react2.default.createElement("link", {
	      rel: "icon",
	      type: "image/png",
	      sizes: "16x16",
	      href: "/favicons/favicon-16x16.png"
	    }),
	    _react2.default.createElement("link", {
	      rel: "mask-icon",
	      href: "/favicons/safari-pinned-tab.svg",
	      color: "#343849"
	    }),
	    _react2.default.createElement("meta", { name: "apple-mobile-web-app-title", content: "Sondro" }),
	    _react2.default.createElement("meta", { name: "application-name", content: "Sondro" }),
	    _react2.default.createElement("meta", { name: "msapplication-TileColor", content: "#3498db" }),
	    _react2.default.createElement(
	      "script",
	      { type: "application/ld+json" },
	      JSON.stringify(schemaOrgJSONLD)
	    ),
	    _react2.default.createElement("meta", { property: "og:locale", content: "us_EN" }),
	    _react2.default.createElement("meta", { property: "og:site_name", content: _website2.default.facebook }),
	    _react2.default.createElement("meta", { property: "og:url", content: postSEO ? postURL : newsURL }),
	    postSEO ? _react2.default.createElement("meta", { property: "og:type", content: "article" }) : null,
	    _react2.default.createElement("meta", { property: "og:title", content: title }),
	    _react2.default.createElement("meta", { property: "og:description", content: description }),
	    _react2.default.createElement("meta", { property: "og:image", content: image }),
	    _react2.default.createElement("meta", { name: "twitter:card", content: "summary_large_image" }),
	    _react2.default.createElement("meta", { name: "twitter:creator", content: _website2.default.twitter }),
	    _react2.default.createElement("meta", { name: "twitter:title", content: title }),
	    _react2.default.createElement("meta", { name: "twitter:description", content: description }),
	    _react2.default.createElement("meta", { name: "twitter:image", content: image })
	  );
	};
	
	exports.default = SEO;
	
	
	SEO.propTypes = {
	  postNode: _propTypes2.default.object,
	  postPath: _propTypes2.default.string,
	  postSEO: _propTypes2.default.bool
	};
	module.exports = exports["default"];

/***/ }),

/***/ 76:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactEmotion = __webpack_require__(3);
	
	var _reactEmotion2 = _interopRequireDefault(_reactEmotion);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gatsbyLink = __webpack_require__(6);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _FxVignette = __webpack_require__(22);
	
	var _FxVignette2 = _interopRequireDefault(_FxVignette);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Row = /*#__PURE__*/(0, _reactEmotion2.default)('div', {
	  target: 'eln90ry0'
	})('display:flex;flex-wrap:wrap;justify-content:space-between;margin-top:2rem;margin-bottom:1rem;padding-right:2rem;padding-left:2rem;');
	
	// import { theme } from '../../config/theme';
	
	
	var ImageOverlay = /*#__PURE__*/(0, _reactEmotion2.default)('div', {
	  target: 'eln90ry1'
	})('border-radius:', function (props) {
	  return props.theme.borderRadius.main;
	}, ';position:absolute;top:-1px;right:-1px;left:-1px;bottom:-1px;z-index:2;opacity:0.1;transition:opacity ', function (props) {
	  return props.theme.transitions.main.duration;
	}, ';background-image:linear-gradient(\n    30deg,', function (props) {
	  return props.theme.colors.cool.light;
	}, ' 0%,', function (props) {
	  return props.theme.colors.cool.dark;
	}, ' 100%\n  );');
	
	var Wrap = /*#__PURE__*/(0, _reactEmotion2.default)('div', {
	  target: 'eln90ry2'
	})('position:relative;transform:skewY(-3deg);box-shadow:', function (props) {
	  return props.theme.set.light.shadow.feature.small.main;
	}, ';transition:', function (props) {
	  return props.theme.transitions.boom.transition;
	}, ';border-radius:', function (props) {
	  return props.theme.borderRadius.main;
	}, ';height:15rem;');
	
	var StyledDiv = /*#__PURE__*/(0, _reactEmotion2.default)('div', {
	  target: 'eln90ry3'
	})('position:absolute;top:0;left:0;right:0;bottom:0;display:block;/*\n  justify-content:center;align-items:center;*/\n  padding:1rem;z-index:9;');
	
	var Image = /*#__PURE__*/(0, _reactEmotion2.default)('div', {
	  target: 'eln90ry4'
	})('position:absolute;overflow:hidden;top:-1px;right:-1px;left:-1px;bottom:-1px;border-radius:', function (props) {
	  return props.theme.borderRadius.main;
	}, ';img{border-radius:', function (props) {
	  return props.theme.borderRadius.main;
	}, ';object-fit:cover;width:100%;height:100%;}');
	
	var Title = /*#__PURE__*/(0, _reactEmotion2.default)('h4', {
	  target: 'eln90ry5'
	})('color:', function (props) {
	  return props.theme.colors.pure.bright;
	}, ';margin-bottom:0;font-family:', function (props) {
	  return props.theme.fontFamily.button;
	}, ';font-size:1.75rem;text-shadow:', function (props) {
	  return props.theme.set.light.shadow._3d;
	}, ';top:11rem;left:-1.5rem;position:relative;');
	
	var Grid = /*#__PURE__*/(0, _reactEmotion2.default)('div', {
	  target: 'eln90ry6'
	})('display:grid;grid-template-columns:repeat(2,1fr);grid-row-gap:2rem;grid-column-gap:2rem;height:21rem;justify-content:center;align-items:center;@media (max-width:1000px){grid-template-columns:1fr;}');
	
	var Excerpt = /*#__PURE__*/(0, _reactEmotion2.default)('div', {
	  target: 'eln90ry7'
	})('position:absolute;display:block;z-index:99;top:0px;width:100%\n  height:100%;opacity:0;visibility:hidden;padding:10% 1rem 1rem 1rem;color:', function (props) {
	  return props.theme.colors.pure.bright;
	});
	
	var Clicker = /*#__PURE__*/(0, _reactEmotion2.default)(_gatsbyLink2.default, {
	  target: 'eln90ry8'
	})('font-size:1.25rem;position:relative;display:block;width:100%;height:17rem;&:focus,&:hover{', Wrap, '{box-shadow:', function (props) {
	  return props.theme.set.light.shadow.feature.small.hover;
	}, ';transform:translateY(-12px) skewY(-1deg);}', ImageOverlay, '{opacity:0.9;}', StyledDiv, '{/*\n      background:linear-gradient(\n        to bottom,rgba(0,0,0,0) 0%,rgba(0,0,0,0.4) 35%,rgba(0,0,0,0.5) 50%,rgba(0,0,0,0.4) 65%,rgba(0,0,0,0) 100%\n      );border-radius:', function (props) {
	  return props.theme.borderRadius.main;
	}, ';transition:opacity ', function (props) {
	  return props.theme.transitions.main.duration;
	}, ';*/}', Excerpt, '{visibility:visible;opacity:1;transition:opacity ', function (props) {
	  return props.theme.transitions.main.duration;
	}, ';', Excerpt, '{}}}@media (max-width:800px){flex-basis:100%;max-width:100%;width:100%;margin-bottom:2rem;font-size:1.35rem;', Excerpt, '{top:-8%;}}@media (min-width:800px){font-size:1.1225rem;', Excerpt, '{top:-3%;}}@media (min-width:1200px){font-size:1.35rem;', Excerpt, '{top:-1.25rem;}}');
	
	var SpanCss = /*#__PURE__*/(0, _reactEmotion2.default)('span', {
	  target: 'eln90ry9'
	})('position:relative;display:block;width:49%;height:17rem;@media (max-width:800px){flex-basis:100%;max-width:100%;width:100%;margin-bottom:2rem;}');
	
	var TapDiv = /*#__PURE__*/(0, _reactEmotion2.default)('div', {
	  target: 'eln90ry10'
	})('background-color:rgba(100,0,0,0.5);position:relative;z-index:999;top:-0rem;left:-2rem;width:150%;height:200%;opacity:0;@media (max-width:600px){z-index:999;display:inline;}');
	var TapRadio = /*#__PURE__*/(0, _reactEmotion2.default)('input', {
	  target: 'eln90ry11'
	})('position:absolute;z-index:-99;top:-0.25rem;width:100%;height:100%;opacity:0;display:none;@media (max-width:600px){z-index:9999;display:inline;&:checked + label{display:none;}&:checked{display:none;}&:unchecked{', TapDiv, '{display:inline;}}&:hover ~ ', Clicker, ',&:checked ~ ', Clicker, ',', Clicker, ':focus{', Wrap, '{box-shadow:', function (props) {
	  return props.theme.set.light.shadow.feature.small.hover;
	}, ';transform:translateY(-12px) skewY(1deg);}', ImageOverlay, '{opacity:0.9;}', StyledDiv, '{/*\n      background:linear-gradient(\n        to bottom,rgba(0,0,0,0) 0%,rgba(0,0,0,0.4) 35%,rgba(0,0,0,0.5) 50%,rgba(0,0,0,0.4) 65%,rgba(0,0,0,0) 100%\n      );border-radius:', function (props) {
	  return props.theme.borderRadius.main;
	}, ';transition:opacity ', function (props) {
	  return props.theme.transitions.main.duration;
	}, ';*/}', Excerpt, '{visibility:visible;opacity:1;transition:opacity ', function (props) {
	  return props.theme.transitions.main.duration;
	}, ';}}');
	
	var Suggestions = function Suggestions(_ref) {
	  var left = _ref.left,
	      right = _ref.right;
	
	  //alert(JSON.stringify(left));
	  //src={right.frontmatter.cover.childImageSharp.resize.src}
	  var thumbSize = 600;
	
	  return _react2.default.createElement(
	    Row,
	    null,
	    left && _react2.default.createElement(
	      SpanCss,
	      null,
	      _react2.default.createElement(TapRadio, { type: 'radio', name: 'r' }),
	      _react2.default.createElement(
	        'label',
	        { style: { position: 'absolute' } },
	        _react2.default.createElement(TapDiv, { className: 'TapDiv', id: 'TapDiv', name: 'r' })
	      ),
	      _react2.default.createElement(
	        Clicker,
	        { to: left.fields.slug },
	        _react2.default.createElement(
	          Wrap,
	          null,
	          _react2.default.createElement(
	            Image,
	            null,
	            _react2.default.createElement(
	              Excerpt,
	              null,
	              left.excerpt
	            ),
	            _react2.default.createElement(_FxVignette2.default, null),
	            _react2.default.createElement('img', { src: left.frontmatter.cover.childImageSharp.resize.src, alt: left.frontmatter.title })
	          ),
	          _react2.default.createElement(
	            StyledDiv,
	            null,
	            _react2.default.createElement(
	              Title,
	              null,
	              left.frontmatter.title
	            )
	          ),
	          _react2.default.createElement(ImageOverlay, null)
	        )
	      )
	    ),
	    right && _react2.default.createElement(
	      SpanCss,
	      null,
	      _react2.default.createElement(TapRadio, { type: 'radio', name: 'r' }),
	      _react2.default.createElement(
	        'label',
	        { style: { position: 'absolute' } },
	        _react2.default.createElement(TapDiv, { className: 'TapDiv', id: 'TapDiv', name: 'r' })
	      ),
	      _react2.default.createElement(
	        Clicker,
	        { to: right.fields.slug },
	        _react2.default.createElement(
	          Wrap,
	          null,
	          _react2.default.createElement(
	            Image,
	            null,
	            _react2.default.createElement(
	              Excerpt,
	              null,
	              right.excerpt
	            ),
	            _react2.default.createElement(_FxVignette2.default, null),
	            _react2.default.createElement('img', { src: right.frontmatter.cover.childImageSharp.resize.src, alt: right.frontmatter.title })
	          ),
	          _react2.default.createElement(
	            StyledDiv,
	            null,
	            _react2.default.createElement(
	              Title,
	              null,
	              right.frontmatter.title
	            )
	          ),
	          _react2.default.createElement(ImageOverlay, null)
	        )
	      )
	    )
	  );
	};
	
	// const Suggestions = ({ left, right }) => {
	//   return (
	//     <Grid>
	//       <Clicker to={left.fields.slug}>
	//         <Wrap>
	//           <Image>
	//             <img
	//               src={left.frontmatter.cover.childImageSharp.resize.src}
	//               alt={left.frontmatter.title}
	//             />
	//           </Image>
	//           <StyledDiv>
	//             <Title>{left.frontmatter.title}</Title>
	//           </StyledDiv>
	//           <ImageOverlay />
	//         </Wrap>
	//       </Clicker>
	//       <Clicker to={right.fields.slug}>
	//         <Wrap>
	//           <Image>
	//             <img
	//               src={right.frontmatter.cover.childImageSharp.resize.src}
	//               alt={right.frontmatter.title}
	//             />
	//           </Image>
	//           <StyledDiv>
	//             <Title>{right.frontmatter.title}</Title>
	//           </StyledDiv>
	//           <ImageOverlay />
	//         </Wrap>
	//       </Clicker>
	//     </Grid>
	//   );
	// };
	
	exports.default = Suggestions;
	
	
	Suggestions.propTypes = {
	  left: _propTypes2.default.any.isRequired,
	  right: _propTypes2.default.any.isRequired
	};
	module.exports = exports['default'];

/***/ }),

/***/ 131:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _reactEmotion = __webpack_require__(3);
	
	var _reactEmotion2 = _interopRequireDefault(_reactEmotion);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TextPlated = /*#__PURE__*/(0, _reactEmotion2.default)('span', {
	  target: 'es18um60'
	})('text-shadow:0px 0px 0 ', function (props) {
	  return props.theme.colors.cool.ink;
	}, ',1px 0px 0 ', function (props) {
	  return props.theme.colors.cool.ink;
	}, ',0px 1px 0 ', function (props) {
	  return props.theme.colors.cool.ink;
	}, ',1px 1px 0 ', function (props) {
	  return props.theme.colors.cool.ink;
	}, ';');
	
	exports.default = TextPlated;
	module.exports = exports['default'];

/***/ }),

/***/ 79:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactEmotion = __webpack_require__(3);
	
	var _reactEmotion2 = _interopRequireDefault(_reactEmotion);
	
	var _Wave = __webpack_require__(78);
	
	var _Wave2 = _interopRequireDefault(_Wave);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Wrapper = /*#__PURE__*/(0, _reactEmotion2.default)('div', {
	  target: 'e14kpdav0'
	})('z-index:9;width:100%;top:8.5rem;position:absolute;@media (max-width:899px){top:4.6rem;}@media (max-width:599px){height:4.5rem;top:1.4rem;}@media (max-width:450px){height:4.5rem;top:2.38rem;}/*  \n  @media (max-width:', function (props) {
	  return props.theme.breakpoints.m;
	}, '){height:5rem;top:1.75rem;}@media (max-width:899px){position:relative;height:4.5rem;}@media (max-width:599px){height:4.5rem;top:5rem;}@media (max-width:450px){height:4.5rem;top:7.2rem;}*/');
	
	var WaveNews = function WaveNews(_ref) {
	  var orientation = _ref.orientation;
	  return _react2.default.createElement(
	    Wrapper,
	    null,
	    _react2.default.createElement(_Wave2.default, { orientation: orientation })
	  );
	};
	
	exports.default = WaveNews;
	
	
	WaveNews.propTypes = {
	  orientation: _propTypes2.default.oneOf(['top', 'bottom'])
	};
	
	WaveNews.defaultProps = {
	  orientation: 'bottom'
	};
	module.exports = exports['default'];

/***/ }),

/***/ 43:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var History = function History() {
	  return _react2.default.createElement(
	    "svg",
	    { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 512 512" },
	    _react2.default.createElement(
	      "g",
	      null,
	      _react2.default.createElement("path", { d: "M504 255.531c.253 136.64-111.18 248.372-247.82 248.468-59.015.042-113.223-20.53-155.822-54.911-11.077-8.94-11.905-25.541-1.839-35.607l11.267-11.267c8.609-8.609 22.353-9.551 31.891-1.984C173.062 425.135 212.781 440 256 440c101.705 0 184-82.311 184-184 0-101.705-82.311-184-184-184-48.814 0-93.149 18.969-126.068 49.932l50.754 50.754c10.08 10.08 2.941 27.314-11.313 27.314H24c-8.837 0-16-7.163-16-16V38.627c0-14.254 17.234-21.393 27.314-11.314l49.372 49.372C129.209 34.136 189.552 8 256 8c136.81 0 247.747 110.78 248 247.531zm-180.912 78.784l9.823-12.63c8.138-10.463 6.253-25.542-4.21-33.679L288 256.349V152c0-13.255-10.745-24-24-24h-16c-13.255 0-24 10.745-24 24v135.651l65.409 50.874c10.463 8.137 25.541 6.253 33.679-4.21z" })
	    )
	  );
	};
	
	exports.default = History;
	module.exports = exports["default"];

/***/ }),

/***/ 283:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Patreon = function Patreon() {
	  return _react2.default.createElement(
	    "svg",
	    {
	      preserveAspectRatio: "xMidYMid meet",
	      height: "100%",
	      width: "100%",
	      viewBox: "-7 -10 272 272",
	      style: { verticalAlign: 'middle' }
	    },
	    _react2.default.createElement(
	      "g",
	      null,
	      _react2.default.createElement("path", { d: "M127.996927,0.00236400943 C57.3035887,0.00236400943 0,57.3059527 0,127.999291 L0,255.934753 L29.7127618,255.934753 L29.7127618,127.999291 C29.7127618,73.7216342 73.7187974,29.7132346 127.998818,29.7132346 C182.278839,29.7132346 226.284874,73.7192702 226.284874,127.999291 C226.284874,180.749797 184.71566,223.784225 132.5519,226.162419 C115.97783,226.026743 101.847673,223.336907 95.6586961,219.528535 L95.6586961,177.286523 C104.895827,183.334605 115.943788,186.860762 127.809224,186.860762 C160.262819,186.860762 186.569043,160.554065 186.569043,128.100943 C186.569043,95.6473489 160.262346,69.3269407 127.809224,69.3269407 C95.3556301,69.3269407 69.049406,95.6482945 69.049406,128.100943 L69.049406,255.937117 C88.4432665,255.919009 109.044663,255.963689 128.003073,255.937117 C198.696411,255.937117 256,198.690265 256,128.001655 C255.995272,57.3035887 198.686955,0 127.998345,0 L127.996927,0.00236400943 Z" })
	    )
	  );
	};
	
	exports.default = Patreon;
	//         fill="#FF5900"
	
	module.exports = exports["default"];

/***/ }),

/***/ 304:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _emotion = __webpack_require__(34);
	
	var _reactEmotion = __webpack_require__(3);
	
	var _reactEmotion2 = _interopRequireDefault(_reactEmotion);
	
	var _reactHelmet = __webpack_require__(10);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _gatsbyImage = __webpack_require__(26);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _gatsbyLink = __webpack_require__(6);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _kebabCase = __webpack_require__(30);
	
	var _kebabCase2 = _interopRequireDefault(_kebabCase);
	
	var _Tags = __webpack_require__(192);
	
	var _Tags2 = _interopRequireDefault(_Tags);
	
	var _TagsTeam = __webpack_require__(193);
	
	var _TagsTeam2 = _interopRequireDefault(_TagsTeam);
	
	var _Suggestions = __webpack_require__(76);
	
	var _Suggestions2 = _interopRequireDefault(_Suggestions);
	
	var _SEO = __webpack_require__(41);
	
	var _SEO2 = _interopRequireDefault(_SEO);
	
	var _Container = __webpack_require__(9);
	
	var _Container2 = _interopRequireDefault(_Container);
	
	var _Content = __webpack_require__(69);
	
	var _Content2 = _interopRequireDefault(_Content);
	
	var _WaveNews = __webpack_require__(79);
	
	var _WaveNews2 = _interopRequireDefault(_WaveNews);
	
	var _Button = __webpack_require__(39);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Footer = __webpack_require__(12);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _Line = __webpack_require__(100);
	
	var _Line2 = _interopRequireDefault(_Line);
	
	var _LinePad = __webpack_require__(40);
	
	var _LinePad2 = _interopRequireDefault(_LinePad);
	
	var _Images = __webpack_require__(134);
	
	var _Images2 = _interopRequireDefault(_Images);
	
	var _hide = __webpack_require__(82);
	
	var _website = __webpack_require__(8);
	
	var _website2 = _interopRequireDefault(_website);
	
	var _TextPlated = __webpack_require__(131);
	
	var _TextPlated2 = _interopRequireDefault(_TextPlated);
	
	var _SlideUp = __webpack_require__(5);
	
	var _SlideUp2 = _interopRequireDefault(_SlideUp);
	
	var _Browser = __webpack_require__(7);
	
	var _Browser2 = _interopRequireDefault(_Browser);
	
	__webpack_require__(91);
	
	var _History = __webpack_require__(43);
	
	var _History2 = _interopRequireDefault(_History);
	
	var _CenterGrid = __webpack_require__(98);
	
	var _CenterGrid2 = _interopRequireDefault(_CenterGrid);
	
	var _SubNav = __webpack_require__(50);
	
	var _SubNav2 = _interopRequireDefault(_SubNav);
	
	var _Patreon = __webpack_require__(283);
	
	var _Patreon2 = _interopRequireDefault(_Patreon);
	
	var _FillBg = __webpack_require__(16);
	
	var _FillBg2 = _interopRequireDefault(_FillBg);
	
	var _FxVignette = __webpack_require__(22);
	
	var _FxVignette2 = _interopRequireDefault(_FxVignette);
	
	var _FxTint = __webpack_require__(73);
	
	var _FxTint2 = _interopRequireDefault(_FxTint);
	
	var _reactDisqusComments = __webpack_require__(38);
	
	var _reactDisqusComments2 = _interopRequireDefault(_reactDisqusComments);
	
	var _DisqusContainer = __webpack_require__(70);
	
	var _DisqusContainer2 = _interopRequireDefault(_DisqusContainer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// import FadeIn from "../components/ani/FadeIn";
	var FooterDiv = /*#__PURE__*/(0, _reactEmotion2.default)('div', {
	  target: 'e15kkmyy0'
	})('text-align:center;color:', function (props) {
	  return props.theme.colors.pure.bright;
	}, ';h1{color:', function (props) {
	  return props.theme.colors.pure.bright;
	}, ';text-shadow:', function (props) {
	  return props.theme.set.light.shadow._3dThin;
	}, ';}');
	
	var IconSpan = /*#__PURE__*/(0, _reactEmotion2.default)('span', {
	  target: 'e15kkmyy1'
	})('top:0.25rem;position:relative;');
	
	var PixDiv = /*#__PURE__*/(0, _reactEmotion2.default)('div', {
	  target: 'e15kkmyy2'
	})('top:0.35rem;position:relative;');
	
	var ImagesIconSpan = /*#__PURE__*/(0, _reactEmotion2.default)('span', {
	  target: 'e15kkmyy3'
	})('top:-0.35rem;left:0.25rem;position:relative;');
	
	var pulse = /*#__PURE__*/(0, _reactEmotion.keyframes)('0%{transform:scale(1);animation-timing-function:ease-in;transform-origin:16% 84%;;translate(1.25remm,0.9375 );}25%{animation-timing-function:ease-out;transform:scale(1.05);transform-origin:16% 84%;;translate(1.25remm,0.9375 );}50%{transform:scale(1.125);animation-timing-function:ease-in;transform-origin:16% 84%;;translate(1.25remm,0.9375 );}to{transform:scale(1);animation-timing-function:ease-out;transform-origin:16% 84%;;translate(1.25remm,0.9375 );}');
	
	var Wrapper = /*#__PURE__*/(0, _reactEmotion2.default)('div', {
	  target: 'e15kkmyy4'
	})('height:600px;position:relative;overflow:hidden;.gatsby-image-wrapper{z-index:0;height:600px;img{animation:', pulse, ' 30s infinite;animation-delay:1400ms;}}@media (max-width:', function (props) {
	  return props.theme.breakpoints.m;
	}, '){height:500px;.gatsby-image-wrapper{height:500px;}}@media (max-width:', function (props) {
	  return props.theme.breakpoints.s;
	}, '){height:400px;.gatsby-image-wrapper{height:400px;}}');
	
	var Hero = /*#__PURE__*/(0, _reactEmotion2.default)('div', {
	  target: 'e15kkmyy5'
	})('position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);z-index:99;color:', function (props) {
	  return props.theme.colors.pure.bright;
	}, ';display:flex;flex-direction:column;width:100%;max-width:', function (props) {
	  return props.theme.layout.base;
	}, ';padding:0 2rem;text-align:center;h2{color:', function (props) {
	  return props.theme.colors.pure.bright;
	}, ';text-shadow:', function (props) {
	  return props.theme.set.light.shadow._3d;
	}, ';}');
	
	var TitleH2 = /*#__PURE__*/(0, _reactEmotion2.default)('h2', {
	  target: 'e15kkmyy6'
	})('font-size:2.95rem;color:', function (props) {
	  return props.theme.colors.pure.bright;
	}, ';text-shadow:', function (props) {
	  return props.theme.set.light.shadow._3d;
	}, ';');
	
	var Information = /*#__PURE__*/(0, _reactEmotion2.default)('div', {
	  target: 'e15kkmyy7'
	})('font-size:1.26rem;margin-top:2rem;font-family:', function (props) {
	  return props.theme.fontFamily.heading;
	}, ';text-shadow:1px 0px 0 ', function (props) {
	  return props.theme.colors.cool.ink;
	}, ',0px 1px 0 ', function (props) {
	  return props.theme.colors.cool.ink;
	}, ',1px 1px 0 ', function (props) {
	  return props.theme.colors.cool.ink;
	}, ';a{color:', function (props) {
	  return props.theme.colors.warm.dark;
	}, ';transition:all 0.4s;&:hover{color:', function (props) {
	  return props.theme.colors.warm.base;
	}, ';}&:focus{color:white;}}');
	
	var TeamsStyle = /*#__PURE__*/(0, _reactEmotion2.default)('div', {
	  target: 'e15kkmyy8'
	})('font-size:1.26rem;margin-top:-1rem;margin-bottom:-0.5rem;font-family:', function (props) {
	  return props.theme.fontFamily.heading;
	}, ';text-shadow:1px 0px 0 ', function (props) {
	  return props.theme.colors.cool.ink;
	}, ',0px 1px 0 ', function (props) {
	  return props.theme.colors.cool.ink;
	}, ',1px 1px 0 ', function (props) {
	  return props.theme.colors.cool.ink;
	}, ';a{color:', function (props) {
	  return props.theme.colors.fire.light;
	}, ';transition:all 0.4s;&:hover{color:', function (props) {
	  return props.theme.colors.warm.light;
	}, ';}&:focus{color:white;}}');
	
	var ButtonStyle = /*#__PURE__*/(0, _reactEmotion2.default)('span', {
	  target: 'e15kkmyy9'
	})('svg{position:relative;top:-0.2rem;max-height:2rem;max-width:2rem;g{stroke:', function (props) {
	  return props.theme.set.light.placeholder;
	}, ';fill:', function (props) {
	  return props.theme.colors.cool.dim0;
	}, ';stroke-width:18;}}');
	// stroke-width: 18;
	var fontBold = /*#__PURE__*/(0, _emotion.css)('font-weight:700;');
	var Shortcut = /*#__PURE__*/(0, _reactEmotion2.default)('div', {
	  target: 'e15kkmyy10'
	})('position:relative;z-index:0;top:-5.25rem;height:1px;@media (max-width:350px){top:-5.25rem;}');
	
	var teamsLink = '';
	var teamsURL = '';
	var SlideUp00 = /*#__PURE__*/(0, _reactEmotion2.default)('div', {
	  target: 'e15kkmyy11'
	})();
	
	var Post = function Post(_ref) {
	  var _ref$pathContext = _ref.pathContext,
	      slug = _ref$pathContext.slug,
	      left = _ref$pathContext.left,
	      right = _ref$pathContext.right,
	      postNode = _ref.data.markdownRemark,
	      location = _ref.location;
	
	  var post = postNode.frontmatter;
	  var sizes = post.cover.childImageSharp.sizes;
	
	  if (!post.id) {
	    post.id = slug;
	  }
	  _gatsbyImage2.default.sizes = sizes;
	
	  if (typeof post.teams[1] !== 'undefined') {
	    teamsLink = post.teams[0] + '+';
	    if (typeof window !== 'undefined') {
	      teamsURL = window.location.hostname;
	    }
	
	    teamsURL = location.pathname + '/#teams';
	    if (teamsURL.match(/\/\/#/g)) {
	      teamsURL = teamsURL.replace(/\/\/#/g, '/#');
	    }
	  } else {
	    teamsLink = post.teams[0];
	    teamsURL = '/teams/' + (0, _kebabCase2.default)(teamsLink);
	  }
	  // ---------------------------------------------------------------
	  // Disqus
	  // ---------------------------------------------------------------
	  var disqus = {
	    shortname: 'sondro',
	    url: '' + location.hostname + post.title.text,
	    identifier: location.pathname,
	    title: post.title.text,
	    language: 'en'
	  };
	  // ---------------------------------------------------------------
	  if ((0, _Browser2.default)() === 'chrome') {
	    SlideUp00 = _SlideUp2.default;
	  }
	  return _react2.default.createElement(
	    _react2.default.Fragment,
	    null,
	    _react2.default.createElement(_reactHelmet2.default, { title: post.title + ' | ' + _website2.default.siteTitle }),
	    _react2.default.createElement(_SEO2.default, { postPath: slug, postNode: postNode, postSEO: true }),
	    _react2.default.createElement(
	      Wrapper,
	      null,
	      _react2.default.createElement(
	        Hero,
	        null,
	        _react2.default.createElement(
	          SlideUp00,
	          { delay: 300, fromY: '0px', fromX: '32px' },
	          _react2.default.createElement(
	            TitleH2,
	            null,
	            post.title
	          )
	        ),
	        _react2.default.createElement(
	          SlideUp00,
	          { delay: 880, fromY: '0px', fromX: '-22px' },
	          _react2.default.createElement(
	            TeamsStyle,
	            null,
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { to: teamsURL },
	              '@' + teamsLink
	            )
	          )
	        ),
	        _react2.default.createElement(
	          SlideUp00,
	          { delay: 1300, fromY: '8px', fromX: '0px' },
	          _react2.default.createElement(
	            Information,
	            null,
	            post.date,
	            ' | ',
	            postNode.timeToRead,
	            'm Read | ',
	            _react2.default.createElement('span', { className: _hide.hideS }),
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { to: '/topics/' + (0, _kebabCase2.default)(post.topic) },
	              '^' + post.topic
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(_FxVignette2.default, null),
	      _react2.default.createElement(_FxTint2.default, null),
	      _react2.default.createElement(_WaveNews2.default, null),
	      _react2.default.createElement(_gatsbyImage2.default, { sizes: sizes })
	    ),
	    _react2.default.createElement(
	      _Container2.default,
	      null,
	      _react2.default.createElement(
	        _FillBg2.default,
	        null,
	        _react2.default.createElement(
	          SlideUp00,
	          { delay: 250, fromY: '0px' },
	          _react2.default.createElement(
	            _SubNav2.default,
	            null,
	            _react2.default.createElement(
	              PixDiv,
	              null,
	              _react2.default.createElement(
	                _gatsbyLink2.default,
	                { to: '/pix' },
	                _react2.default.createElement(
	                  ImagesIconSpan,
	                  null,
	                  _react2.default.createElement(_Images2.default, null)
	                ),
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  '\xA0' + ':' + '\xA0' + 'PIX'
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          SlideUp00,
	          { delay: 425, fromY: '12px' },
	          _react2.default.createElement(_Content2.default, { input: postNode.html }),
	          _react2.default.createElement(Shortcut, { name: 'teams' }),
	          _react2.default.createElement(
	            _DisqusContainer2.default,
	            { type: 'article' },
	            _react2.default.createElement(_Line2.default, null),
	            _react2.default.createElement(_TagsTeam2.default, { tags: post.teams, type: 'teams' }),
	            _react2.default.createElement(_Tags2.default, { tags: post.tags }),
	            _react2.default.createElement('div', { style: { padding: '0.25rem' } }),
	            _react2.default.createElement(
	              'p',
	              null,
	              _react2.default.createElement(
	                'span',
	                { className: fontBold },
	                'Like this post?'
	              ),
	              ' Read more from the',
	              ' ',
	              _react2.default.createElement(
	                _TextPlated2.default,
	                null,
	                _react2.default.createElement(
	                  _gatsbyLink2.default,
	                  { to: '/topics/' + (0, _kebabCase2.default)(post.topic) },
	                  '^' + post.topic
	                )
	              ),
	              ' ',
	              'topic.'
	            ),
	            _react2.default.createElement(_reactDisqusComments2.default, {
	              shortname: disqus.shortname,
	              identifier: disqus.identifier
	              // url={disqus.url}
	              , title: disqus.title,
	              language: disqus.language
	            })
	          ),
	          _react2.default.createElement(
	            SlideUp00,
	            { fromY: '0px', fromX: '90px', delay: 1400 },
	            _react2.default.createElement(_LinePad2.default, null)
	          ),
	          _react2.default.createElement('br', null),
	          _react2.default.createElement(
	            _CenterGrid2.default,
	            null,
	            _react2.default.createElement(
	              _SubNav2.default,
	              null,
	              _react2.default.createElement(
	                PixDiv,
	                null,
	                _react2.default.createElement(
	                  _gatsbyLink2.default,
	                  { to: '/pix' },
	                  _react2.default.createElement(
	                    ImagesIconSpan,
	                    null,
	                    _react2.default.createElement(_Images2.default, null)
	                  ),
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    '\xA0' + ':' + '\xA0' + 'PIX'
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'span',
	                null,
	                '\xA0' + '\xA0' + '\xA0' + '\xA0' + '\xA0' + '\xA0'
	              ),
	              _react2.default.createElement(
	                _gatsbyLink2.default,
	                { to: '/news' },
	                _react2.default.createElement(
	                  IconSpan,
	                  null,
	                  _react2.default.createElement(_History2.default, null)
	                ),
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  '\xA0' + ':' + '\xA0' + 'NEWS'
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _Container2.default,
	            null,
	            _react2.default.createElement(_Suggestions2.default, { left: left, right: right }),
	            _react2.default.createElement('div', { style: { padding: '2.6823rem' } })
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _Footer2.default,
	      null,
	      _react2.default.createElement(
	        FooterDiv,
	        null,
	        _react2.default.createElement(
	          'h1',
	          null,
	          'Get more insights!'
	        ),
	        _react2.default.createElement(
	          'a',
	          { href: 'https://www.patreon.com/Sondro', target: '_blank', rel: 'noopener noreferrer' },
	          _react2.default.createElement(
	            ButtonStyle,
	            null,
	            _react2.default.createElement(
	              _Button2.default,
	              { type: 'alt' },
	              _react2.default.createElement(_Patreon2.default, null),
	              '\xA0',
	              ':',
	              '\xA0',
	              ':',
	              '\xA0',
	              'Patreon',
	              '\xA0',
	              ':',
	              '\xA0',
	              ':'
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = Post;
	
	
	Post.propTypes = {
	  pathContext: _propTypes2.default.shape({
	    slug: _propTypes2.default.string.isRequired
	  }),
	  data: _propTypes2.default.shape({
	    markdownRemark: _propTypes2.default.object.isRequired
	  })
	};
	
	/* eslint no-undef: "off" */
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ }),

/***/ 91:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-post-jsx-437aef5902481b8db6d9.js